import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout, { PageHeader } from "@/components/Layout";
import { api, fmtINR, fmtNum } from "@/lib/api";
import { Search } from "lucide-react";

export default function FloorPlanQuotations() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => { api.get("/floorplan/quotations").then((r) => setRows(r.data)); }, []);

  const filtered = rows.filter((r) => {
    if (!q) return true;
    const hay = [r.quote_number, r.layout_plan_number, r.layout_name, r.client?.company, r.client?.name].filter(Boolean).join(" ").toLowerCase();
    return hay.includes(q.toLowerCase());
  });

  return (
    <Layout>
      <PageHeader eyebrow="Floor Plan · Quotations" title="Layout Quotations" />
      <div className="p-8">
        <div className="panel">
          <div className="flex items-center gap-3 px-5 py-4 border-b border-line">
            <Search size={16} className="text-ink-faint" />
            <input value={q} onChange={(e) => setQ(e.target.value)} className="flex-1 outline-none bg-transparent text-sm" placeholder="Search…" />
          </div>
          {filtered.length === 0 ? (
            <div className="p-16 text-center text-ink-muted"><div className="label-tech">No layout quotations yet</div></div>
          ) : (
            <table className="w-full grid-lines">
              <thead>
                <tr><th>Quote #</th><th>Layout</th><th>Client</th><th className="num">Items</th><th className="num">Running ft</th><th className="num">Weight</th><th className="num">Grand total</th><th>Status</th></tr>
              </thead>
              <tbody>
                {filtered.map((r) => (
                  <tr key={r.id} onClick={() => navigate(`/floorplan-quotations/${r.id}`)} className="cursor-pointer hover:bg-surfaceAlt" data-testid={`fpq-row-${r.quote_number}`}>
                    <td className="mono font-bold">{r.quote_number}</td>
                    <td><div className="font-bold text-sm">{r.layout_name}</div><div className="text-xs text-ink-muted mono">{r.layout_plan_number}</div></td>
                    <td>{r.client?.company || r.client?.name || "—"}</td>
                    <td className="num">{r.total_items}</td>
                    <td className="num mono text-xs">{fmtNum(r.total_running_ft, 1)} ft</td>
                    <td className="num mono text-xs">{fmtNum(r.total_weight_kg, 1)} kg</td>
                    <td className="num font-semibold">{fmtINR(r.grand_total)}</td>
                    <td><span className="label-tech">{r.status}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </Layout>
  );
}
